<main>
    <section class="donate">
        <div class="content">
            <div class="left">
                <div class="left-content">
                    <h2>
                        <div class="cursive">Champion</div>
                        <div>Sponsorsh<span class="i-with-dot">i</span>ps</div> 
                    </h2>

                    <div class="iframe-placeholder">
                        <!-- <script src="https://donorbox.org/widget.js" paypalExpress="false"></script><iframe allowpaymentrequest="allowpaymentrequest" seamless="seamless" frameborder="0" scrolling="no" height="900px" name="donorbox" src="https://donorbox.org/embed/p2-jan-2024" style="max-width: 500px; min-width: 250px; max-height:none!important" width="100%"></iframe> -->
                        <script src="https://donorbox.org/widget.js" paypalExpress="false"></script><iframe src="https://donorbox.org/embed/champion-sponsor-2024" name="donorbox" allowpaymentrequest="allowpaymentrequest" seamless="seamless" frameborder="0" scrolling="no" height="1100px" width="100%" style="max-width: 500px; min-width: 250px; max-height:none!important"></iframe>
                    </div>
                </div>
            </div>
            <div class="right">
                <img class="mobile" src="../../assets/Mobile/Donation-background.png" />
                <img class="tablet" src="../../assets/Tablet/Donation-background.png" />
            </div>
        </div>
    </section>
</main>
